import { Nullable } from '@clearverify/types';

import { PeoPayrollProviderInfoFragment } from 'src/api';
import { AddressFieldsFormFields } from 'src/constants/address';

import {
  PeoPayrollProviderCompanyInformationFormFields,
  PeoPayrollProviderCompanyInformationFormValues,
} from '../types';

export const getPeoPayrollProviderCompanyInformationInitialValues = (
  peoPayrollProvider: Nullable<PeoPayrollProviderInfoFragment>,
): Partial<Omit<PeoPayrollProviderCompanyInformationFormValues, 'headquarters'>> & {
  headquarters?: Partial<PeoPayrollProviderCompanyInformationFormValues['headquarters']>;
} => ({
  [PeoPayrollProviderCompanyInformationFormFields.displayName]:
    peoPayrollProvider?.displayName ?? undefined,
  [PeoPayrollProviderCompanyInformationFormFields.fein]: peoPayrollProvider?.fein ?? undefined,
  [PeoPayrollProviderCompanyInformationFormFields.industry]: peoPayrollProvider?.industry
    ? {
        label: peoPayrollProvider.industry,
        value: peoPayrollProvider.industry,
      }
    : undefined,
  [PeoPayrollProviderCompanyInformationFormFields.corporateStructure]:
    peoPayrollProvider?.corporateStructure,
  [PeoPayrollProviderCompanyInformationFormFields.numberOfEmployees]:
    peoPayrollProvider?.numberOfEmployees,
  [PeoPayrollProviderCompanyInformationFormFields.contactEmail]:
    peoPayrollProvider?.contactEmail ?? undefined,
  [PeoPayrollProviderCompanyInformationFormFields.contactPhoneNumber]:
    peoPayrollProvider?.contactPhoneNumber,
  [PeoPayrollProviderCompanyInformationFormFields.taxYearEndDate]:
    peoPayrollProvider?.taxYearEndDate,
  [PeoPayrollProviderCompanyInformationFormFields.defaultDisclaimer]:
    peoPayrollProvider?.defaultDisclaimer,
  [PeoPayrollProviderCompanyInformationFormFields.headquarters]: peoPayrollProvider?.headquarters
    ? {
        [AddressFieldsFormFields.street]: peoPayrollProvider?.headquarters.street ?? undefined,
        [AddressFieldsFormFields.city]: peoPayrollProvider?.headquarters.city ?? undefined,
        [AddressFieldsFormFields.county]: peoPayrollProvider?.headquarters.county,
        [AddressFieldsFormFields.state]: peoPayrollProvider?.headquarters.state ?? undefined,
        [AddressFieldsFormFields.zipCode]: peoPayrollProvider?.headquarters.zipCode ?? undefined,
      }
    : undefined,
});
